import { DATE_FORMAT_RFC } from 'common/constants'
import moment, { Moment } from 'moment'
import { useCallback } from 'react'

export const useActionHandlers = (
  name: string,
  minDateValue: any,
  maxDateValue: any,
  setValue: (value: any) => void,
  setFieldValue: (field: string, value: any) => void,
  afterChanged: ((value: Moment | null) => void) | undefined
) => {
  const handleChanged = (newValue: Moment | null): void => {
    if (newValue === null) {
      setFieldValue(name, null)
    } else {
      setFieldValue(name, newValue.format(DATE_FORMAT_RFC))
    }

    afterChanged?.(newValue)
  }

  const handleEdit = () => {
    let currentDate = moment()

    if (minDateValue) {
      let minValue = minDateValue

      if (typeof minValue === 'string') minValue = moment(minValue)
      if (currentDate < minValue) currentDate = minValue
    }

    if (maxDateValue) {
      let maxValue = maxDateValue
      if (typeof maxValue === 'string') maxValue = moment(maxValue)
      if (currentDate > maxValue) currentDate = maxValue
    }

    setValue(currentDate)
    setFieldValue(name, currentDate.format(DATE_FORMAT_RFC))
  }

  const disabledDate = useCallback(
    (current: Moment) => {
      if (minDateValue) {
        let minValue = minDateValue
        if (typeof minValue === 'string') minValue = moment(minValue)
        if (current < minValue) return true
      }

      if (maxDateValue) {
        let maxValue = maxDateValue
        if (typeof maxValue === 'string') maxValue = moment(maxValue)
        return current.format(DATE_FORMAT_RFC) > maxValue.format(DATE_FORMAT_RFC)
      }

      return false
    },
    [minDateValue, maxDateValue]
  )

  return { handleChanged, handleEdit, disabledDate }
}
